import styled, { css } from 'styled-components';
import convertHexToRgba from '~/helpers/convertHexToRgba';
import getColor from '~/helpers/getColor';

export const ResumeModalStyled = styled.div.attrs({
  className: 'resume-screen',
})`
  ${({ theme }) => {
    const { colors, media } = theme;
    return css`
      background-color: ${colors.primary.white};
      box-shadow: 0 20px 40px 0 ${convertHexToRgba(colors.primary.black, 0.25)};
      width: 1110px;
      height: 380px;
      line-height: 34px;
      display: flex;
      flex-direction: column;
      padding: 0px 0px 20px;
      border-radius: 32px;
      position: relative;
      text-align: center;
      justify-content: center;

      ${media.tablet.only} {
        width: 720px;
      }

      ${media.mobile.down} {
        width: 310px;
        padding: 4% 2.5%;
        overflow-y: auto;
        overflow-x: hidden;
      }

      .icon--fill-close-thin {
        fill: ${colors.secondary.gray};
        height: 16px;
        position: absolute;
        right: 1.5rem;
        top: 1.5rem;
        cursor: pointer;
      }

      .icon--fill-alert {
        width: 64px;
        height: 64px;
        margin: 20px;
      }

      .resume {
        &__header {
          display: flex;
          flex-direction: column;
          align-items: center;
          font-size: 18px;
          ${media.mobile.down} {
            font-size: 16px;
          }
        }

        &__cancel {
          color: ${colors.primary.black};
          background-color: ${colors.primary.whiteSmoke};
          border-color: ${colors.primary.black};
        }
        &__container {
          line-height: 20px;
          display: flex;
          flex-direction: column;
          align-items: center;
          color: ${theme.colors.primary.darkBlue};

          edit-address {
            display: none;
          }
        }

        &__title {
          width: 100%;
          font-size: 34px;
          font-weight: 700;

          ${media.mobile.down} {
            font-size: 20px;
          }
        }

        &__button-container {
          display: flex;
          flex-direction: row;
          justify-content: center;
          width: 100%;
          padding: 0;

          button {
            font-size: 18px;
            max-height: 46px;
            padding: 12px, 24px, 12px, 24px;
            margin: 10px;
            display: flex;
            justify-content: center;
            align-items: center;

            ${media.mobile.down} {
              max-width: 343px;
            }
          }
        }

        &__badge {
          &__icon-wrapper {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 16px;
            height: 16px;
            border: 1px solid black;
            border-radius: 1rem;

            svg {
              width: 1rem;
              height: 1rem;
            }
          }

          &__copy {
            color: ${colors.secondary.black};
          }
        }
      }
    `;
  }}
`;

export const BadgeStyled = styled.div.attrs<{ backgroundColor?: string; borderColor?: string; copyColor?: string; iconColor?: string }>(() => ({
  className: 'resume__badge__wrapper',
}))`
  ${({ theme, backgroundColor, borderColor, copyColor }) => {
    const { colors } = theme;
    const bgColor = backgroundColor ? getColor(backgroundColor) : (colors.gradients?.stripedTeal || colors.secondary.mint);
    const border = borderColor ? getColor(borderColor) : colors.secondary.pumice;
    const copyTextColor = copyColor ? getColor(copyColor) : colors.secondary.black;

    return css`
      margin-top: 20px;
      margin-bottom: 20px;
      display: flex;
      justify-content: center;
      align-items: center;

      .resume__badge__content {
        display: flex;
        align-items: center;
        gap: 8px;

        background: ${bgColor};
        border: 3px solid ${border};
        border-radius: 1rem;
        padding: 4px 12px;
      }

      .resume__badge__icon {
        width: 16px;
        height: 16px;
      }

      .resume__badge__copy {
        color: ${copyTextColor};
      }
    `;
  }}
`;
